/*

Pixel Field Editor - developed by Satori, s.r.o. (c) 2014-2015 - zden@satori.sk
---------------------------------
Legal notice: Source code is for internal purposes only of developing
and integrating Pixel Field Editor to the larger asset of Forms+Surfaces
online services. Any modifications must be discussed with Satori, s.r.o. and no derivates to other projects are allowed without prior written permission from Satori, s.r.o.
---------------------------------
Satori, s.r.o. | Jegeho 21 | 821 08 Bratislava | +421-903-258-862 | www.satori.sk

*/

function vec2(x, y)
{
	this.x = x;
	this.y = y;
}

vec2.prototype.rot = function (ang, mx, my)
{
	var x = this.x - mx;
	var y = this.y - my;

	var xr = x * Math.cos(ang) - y*Math.sin(ang);
	var yr = x * Math.sin(ang) + y*Math.cos(ang);

	this.x = xr + mx;
	this.y = yr + my;
}

vec2.prototype.iter = function (xd, yd, i)
{
	this.x = this.x + (xd - this.x) * i;
	this.y = this.y + (yd - this.y) * i;
}

vec2.prototype.copy = function ()
{
	return new vec2(this.x, this.y);
}

vec2.prototype.norm = function ()
{
	var a = Math.sqrt( (this.x * this.x) + (this.y * this.y) );
	this.x /= a;
	this.y /= a;
}

vec2.prototype.dist = function (v)
{
	var xd = (v.x - this.x);
	var yd = (v.y - this.y);
	return Math.sqrt( xd*xd + yd*yd );
}

vec2.prototype.add = function (v)
{
	this.x += v.x;
	this.y += v.y;
}

vec2.prototype.sub = function (v)
{
	this.x -= v.x;
	this.y -= v.y;
}

vec2.prototype.mul = function (v)
{
	this.x *= v.x;
	this.y *= v.y;
}

vec2.prototype.alert = function ()
{
	alert("x:"+this.x+" y:"+this.y)
}
